import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import blog1 from "../../../assets/images/blog1.png";
import blog2 from "../../../assets/images/blog2.png";
import blog3 from "../../../assets/images/blog3.png";
import blog4 from "../../../assets/images/blog4.png";
import NextArrow from "./NextButton";
import PrevArrow from "./PrevButton";
import styles from "./blogslider.module.css";

interface BlogPost {
  title: string;
  date: string;
  readTime: string;
  img: string;
  link: string;
}

const BlogSlider: React.FC<{ countryName?: any }> = ({ countryName }) => {

  const images = [blog1, blog2, blog3, blog4];
  const [blogData, setBlogData] = useState([]);
  


  const settings: any = {
    dots: false,
    infinite:false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1050,
        settings: { 
          // slidesToShow: Math.min(2, blogData?.length || 1),
          // infinite: blogData?.length > 2,
          // arrows: blogData?.length > 2
        },
      },
      {
        breakpoint: 992,
        settings: { 
          // slidesToShow: Math.min(2, blogData?.length || 1),
          // infinite: blogData?.length > 2,
          // arrows: blogData?.length > 2
        },
      },
      {
        breakpoint: 768,
        settings: { 
          slidesToShow: 1,
          // infinite: blogData?.length > 1,
          // arrows: blogData?.length > 1
        },
      },
    ],
  };

  return (
    <>
       <section className={styles.blogs}>
        <div className="container-fluid">
          <h2>Our Recent Blogs</h2>
          <p className={styles.subtitle}>
            Experience affordable data roaming with our travel eSIM solution. Enjoy seamless connectivity without breaking the bank.
          </p>

          <div className={`${styles.blogsgrid} row align-items-start`}>
            {/* Left Big Blog  */}
            <div className="col-lg-6">
            <div className={`${styles.blogcard} ${styles.big}`}>
              <img src={blog1} alt="Malaysia Blog" />
              <div className={styles.content}>
                <span className={styles.date}>April 7, 2025</span>
                <h3>Best eSIM for Malaysia 2025: Best Plans & Coverage</h3>
                <p>
                  Planning a vacation can be overwhelming, but this post offers a step-by-step guide to help readers create a comprehensive travel itinerary. From choosing a destination to booking accommodations and activities, readers will learn how to plan a stress-free and enjoyable trip.
                </p>
                <a href="#" className={styles.readmore}>Read More</a>
              </div>
            </div>
            </div>
            <div className="col-lg-6">
            {/* Right Blogs  */}
            <div className={styles.rightblogs}>
              <div className={styles.blogcard}>
                <div className="col-5">
                  <img src={blog2} alt="Thailand Blog" />
                </div>
                <div className="col-7">
                  <div className={styles.content}>
                    <span className={styles.date}>April 7, 2025</span>
                    <h3 className="clamp clamp2">Best eSIM for Thailand to Access Data Connection 24/7</h3>
                    <p className="clamp clamp2">Benefits of traveling alone, from the freedom to discover new places with new friends.</p>
                  </div>
                </div>
              </div>

              <div className={styles.blogcard}>
                <div className="col-5">
                <img src={blog3} alt="Miami Blog" />
                </div>
                 <div className="col-7">
                <div className={styles.content}>
                  <span className={styles.date}>April 7, 2025</span>
                  <h3 className="clamp clamp2">eSIM for Miami With Unlimited Data, Voice, and Text Plan</h3>
                  <p className="clamp clamp2">Benefits of traveling alone, from the freedom to discover new places with new friends.</p>
                </div>
                </div>
              </div>

              <div className={styles.blogcard}>
                <div className="col-5">
                <img src={blog4} alt="Miami Blog" />
                </div>
                <div className="col-7">
                <div className={styles.content}>
                  <span className={styles.date}>April 7, 2025</span>
                  <h3 className="clamp clamp2">eSIM for Miami With Unlimited Data, Voice, and Text Plan</h3>
                  <p className="clamp clamp2">Benefits of traveling alone, from the freedom to discover new places with new friends.</p>
                </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </section>

    </>
  );
};

export default BlogSlider;
